import { Button } from 'antd';
import { useState } from 'react';

interface DriverInviteButtonProps {
  isInvitable: boolean;
  onInvite: () => Promise<boolean>;
}

/** Texts the driver the link to the app. It can be pressed again; an inactive driver can't sign in, so it is hidden for them. */
export function DriverInviteButton({ isInvitable, onInvite }: DriverInviteButtonProps) {
  const [sending, setSending] = useState(false);
  if (!isInvitable) return null;

  async function send() {
    setSending(true);
    try {
      await onInvite();
    } finally {
      setSending(false);
    }
  }

  return (
    <Button loading={sending} onClick={() => void send()}>
      Send app invite
    </Button>
  );
}
